import React, { useState } from "react";
import { Flags } from "../../../../../../../common/flags";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import BrowserLanguageFilter from "../../browser-language-filter";

const LanguageSelector = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const { i18n, t } = useTranslation();

  const currentLang = i18n.language.substring(0, 2);
  const currentLangUp = currentLang.toUpperCase();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const langs = i18n.languages;

  return (
    <div className="language-selector-wrapper">
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle color="link" className="nav-link-icon">
          <img
            src={Flags[currentLangUp]}
            alt={t("language-" + currentLangUp)}
            className="flag-icon"
          />
          <span>{currentLangUp}</span>
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem header>{t("languages-available")}</DropdownItem>
          {langs.map((lang, i) => (
            <DropdownItem
              key={i}
              onClick={() => {
                changeLanguage(lang);
              }}
            >
              <img
                src={Flags[lang.toUpperCase()]}
                alt={t("language-" + lang.toUpperCase())}
                lang={lang}
                width="20"
                height="20"
                className="me-2"
              />
              {t("language-" + lang.toUpperCase())}
            </DropdownItem>
          ))}
          <DropdownItem divider />
          <DropdownItem toggle={false}>
            <BrowserLanguageFilter />
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default LanguageSelector;
